module.exports = __webpack_public_path__ + "img/1.35b18f24.png";